import { create } from 'zustand';

interface CapturingRecordingState {
  /** The recording currently capturing in this process, or null. */
  recordingId: string | null;
  setCapturing: (recordingId: string) => void;
  clear: () => void;
}

/**
 * Which recording this desktop process started, known the moment
 * `commands.recordingStart` resolves.
 *
 * The entity store cannot answer this promptly: its `recordings` rows arrive
 * only via server-pushed WS `UPSERTED` events, so a locally-started capture is
 * invisible there for a full HTTP-create → broadcast → sync-decode round trip,
 * and forever if that event is dropped. The recording HUD never had the problem
 * because Rust hands it the id as a window prop; this store gives the main
 * window the same local truth instead of making it wait for the server to tell
 * it something it already knew.
 */
export const useCapturingRecordingStore = create<CapturingRecordingState>((set) => ({
  recordingId: null,
  setCapturing: (recordingId) => set({ recordingId }),
  clear: () => set({ recordingId: null }),
}));
